import * as React from 'react';
import { render } from 'react-dom';
import { Contracts } from '../landing_pages/pages/Contracts';
import '../terms_and_conditions/styles.scss';

const root = document.getElementById('contracts');
render(<Contracts />, root);
